import { create } from "zustand";

const STORAGE_KEY = "k162:displayOptions";

interface PersistedShape {
  highlightJSpaceLastThree?: unknown;
}

interface UiState {
  highlightJSpaceLastThree: boolean;
  setHighlightJSpaceLastThree: (value: boolean) => void;
}

const DEFAULTS = {
  highlightJSpaceLastThree: false,
};

function loadPersisted(): typeof DEFAULTS {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw == null) return DEFAULTS;
    const parsed = JSON.parse(raw) as unknown;
    if (parsed && typeof parsed === "object") {
      const candidate = parsed as PersistedShape;
      return {
        highlightJSpaceLastThree:
          typeof candidate.highlightJSpaceLastThree === "boolean"
            ? candidate.highlightJSpaceLastThree
            : DEFAULTS.highlightJSpaceLastThree,
      };
    }
  } catch {
    /* fall through */
  }
  return DEFAULTS;
}

function persist(state: typeof DEFAULTS): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* ignore */
  }
}

export const useUiStore = create<UiState>((set) => ({
  ...loadPersisted(),
  setHighlightJSpaceLastThree: (value) =>
    set({ highlightJSpaceLastThree: value }),
}));

useUiStore.subscribe((state) => {
  persist({ highlightJSpaceLastThree: state.highlightJSpaceLastThree });
});
